import { request } from "@umijs/max";

/** 获取当前租户订阅信息 GET /app/subscription */
export async function getMySubscription() {
  return request<API.Subscription>("/app/subscription", { method: "GET" });
}

/** 获取可用套餐列表（含价格） GET /app/subscription/plans */
export async function getAvailablePlans(country: string = "CN") {
  return request<API.PlanWithPrices[]>("/app/subscription/plans", {
    method: "GET",
    params: { country },
  });
}

/** 创建 Stripe Checkout Session POST /app/subscription/checkout */
export async function createCheckoutSession(data: API.CheckoutRequest) {
  return request<API.CheckoutResponse>("/app/subscription/checkout", {
    method: "POST",
    data,
  });
}

/** 取消订阅 POST /app/subscription/cancel */
export async function cancelSubscription() {
  return request<void>("/app/subscription/cancel", { method: "POST" });
}

/** 自助开启 14 天试用 POST /app/subscription/start-trial */
export async function startTrial() {
  return request<API.Subscription>("/app/subscription/start-trial", {
    method: "POST",
  });
}

/** 创建 Stripe Customer Portal Session POST /app/subscription/portal */
export async function createPortalSession(returnUrl?: string) {
  return request<string>("/app/subscription/portal", {
    method: "POST",
    data: { returnUrl },
  });
}

/** 升级到 PRO（临时，不接入 Stripe） POST /app/subscription/upgrade
 * @deprecated 使用 createCheckoutSession 接入 Stripe 支付
 */
export async function upgradeSubscription() {
  return request<API.Subscription>("/app/subscription/upgrade", {
    method: "POST",
  });
}
